import styled from 'styled-components';
import { WithThemeProps } from '@seeneco-ui/core/styles';


type AccountNameProps = {
	crossout?: boolean;
	muted?: boolean;
} & WithThemeProps;

type ValueProps = {
	red?: boolean;
} & WithThemeProps;

const Root = styled.div`
	position: relative;
	width: 100%;
	height: auto;
	margin-bottom: 40px;
`;

const AccountName = styled.div`
	font-size: 16px;
	font-weight: 500;

	${(p: AccountNameProps) => p.crossout && `
		text-decoration: line-through;
	`}

	${(p: AccountNameProps) => p.muted && `
		color: ${p.theme.color.blackSecondary};
	`}
`;

const Value = styled.span`
	display: inline-block;

	${(p: ValueProps) => p.red && `
		color: ${p.theme.color.dangerPrimary};
	`}
`;

const BankIconLayout = styled.div`
	margin-right: 15px;
`;

const GroupName = styled.div`
	font-size: 16px;
  font-weight: 500;

	@media(max-width: 960px) {
		font-size: 14px;
	}
`;

const AddButtonLayout = styled.div`
	display: flex;
	align-items: center;
	margin-right: 15px;
`;


export {
	Root,
	AccountName,
	Value,
	BankIconLayout,
	GroupName,
	AddButtonLayout,
};
